// extracted by mini-css-extract-plugin
module.exports = {"tabbar":"MobileNav_tabbar__1cHXT","item":"MobileNav_item__1OE-O","title":"MobileNav_title__3bBXS","active":"MobileNav_active__3dJaF","placeholder":"MobileNav_placeholder__25bUD"};